import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { BrowseCoursesPage } from './components/BrowseCoursesPage';

export function BrowseCourses() {
    // A route reload (clear progress, a program switch, or a locale change) remounts the page, which
    // refetches the courses and reloads the saved filters
    const [key] = useAngularToReactRoute();
    return <BrowseCoursesPage key={key} />;
}
